import { WithStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import * as React from 'react';
import { UpwardTransition } from 'src/utils';

import i18n from '../resources/i18n';
import SiteConfig from '../site.config.json';
import { isMobile } from '../utils/MobileCheck';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
		},
		flex: {
			flex: 1,
		},
		frame: {
			overflow: 'auto !important',
			width: '100%',
			['-webkit-overflow-scrolling']: 'touch !important',
		},
	});

interface IProps
	extends React.Props<{}>,
		WithStyles<typeof styles>,
		IELearningHintProps {}

/**
 * eラーニングヒント
 */
class ELearningHint extends React.Component<IProps> {
	protected elmIframe: HTMLIFrameElement | null;
	protected elmParent: HTMLDivElement | null;
	protected elmForm: HTMLFormElement | null;

	protected resizeFrameWrapper: () => void;

	/**
	 * Lifecycle Methods
	 */
	public componentDidUpdate(prevProps: IProps) {
		if (!prevProps.open && this.props.open) {
			this.resizeFrame();
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		if (this.resizeFrameWrapper) {
			const type = isMobile() ? 'orientationchange' : 'resize';
			window.removeEventListener(type, this.resizeFrameWrapper);
		}
	}

	public render() {
		const { classes, preview } = this.props;

		return (
			<Dialog
				fullScreen={true}
				open={this.props.open}
				onClose={this.props.onClose}
				onEntered={this.resizeFrame}
				TransitionComponent={UpwardTransition}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							color="inherit"
							onClick={this.props.onClose}
							aria-label="Close"
						>
							<CloseIcon />
						</IconButton>
						<Typography
							variant="h6"
							color="inherit"
							className={classes.flex}
						>
							{i18n.t('ELearningHint_0001')}
						</Typography>
					</Toolbar>
				</AppBar>
				<div
					className={classes.frame}
					ref={parent => (this.elmParent = parent)}
				>
					<form
						method="POST"
						action={
							SiteConfig.tsqPath +
							'/tsq/pkg/action/el/hint.action'
						}
						target="hintFrame"
						ref={form => this.submitForm(form)}
					>
						<input
							type="hidden"
							name="topicID"
							value={this.props.topicID}
						/>
						<input
							type="hidden"
							name="page"
							value={this.props.page}
						/>
						<input
							type="hidden"
							name="careerID"
							value={this.props.careerID}
						/>
						<input
							type="hidden"
							name="lang"
							value={this.props.lang}
						/>
						<input
							type="hidden"
							name="viewMode"
							value={preview ? '1' : '0'}
						/>
						<input
							type="hidden"
							name="accessType"
							value={preview ? '21' : '10'}
						/>
					</form>
					<iframe
						frameBorder="0"
						title={i18n.t('ELearningHint_0002')}
						name="hintFrame"
						ref={iframe => this.setResizeHandler(iframe)}
					/>
				</div>
			</Dialog>
		);
	}

	/**
	 * フォーム送信
	 * @param form フォーム要素
	 */
	protected submitForm(form: HTMLFormElement | null) {
		if (!form) {
			return;
		}
		this.elmForm = form;
		this.elmForm.submit();
	}

	/**
	 * リサイズハンドラ設定
	 * @param iframe Iフレーム要素
	 */
	protected setResizeHandler(iframe: HTMLIFrameElement | null) {
		if (!iframe) {
			return;
		}
		this.elmIframe = iframe;
		this.elmIframe.onload = () => {
			this.resizeFrame();
			if (!this.resizeFrameWrapper) {
				this.resizeFrameWrapper = () => {
					this.resizeFrame();
				};
				const type = isMobile() ? 'orientationchange' : 'resize';
				window.addEventListener(type, this.resizeFrameWrapper);
			}
		};
	}

	/**
	 * リサイズハンドラ
	 */
	protected resizeFrame = () => {
		const innerHeight =
			window.innerHeight || document.documentElement.clientHeight;
		if (!(this.elmParent && this.elmIframe)) {
			return;
		}
		const rect = this.elmIframe.getBoundingClientRect();
		this.elmIframe.width = this.elmParent.offsetWidth.toString();
		this.elmIframe.height = (
			innerHeight -
			(rect.top - window.pageYOffset) -
			8 -
			32
		).toString();
	};
}

export interface IELearningHintProps {
	topicID: string;
	page: number;
	lang: string;
	careerID: string;
	open: boolean;
	onClose?: React.ReactEventHandler<{}>;
	preview: boolean;
}
export default withStyles(styles)(ELearningHint);



// WEBPACK FOOTER //
// ./src/components/ELearningHint.tsx